import React from "react";
import Logo from "../assets/images/DHL_logo_rgb.svg";
import { Navbar, Container, Dropdown } from "react-bootstrap";
import "../assets/styles/header.scss";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useBranch } from "../auth/BranchContext";

const Header = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const activeAccount = instance.getActiveAccount() || accounts?.[0];
  const { branches, loading: branchesLoading } = useBranch() || {};
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);

  // Roles from idToken claims
  const claims = activeAccount?.idTokenClaims || {};
  const rolesRaw = claims.roles || claims.role || claims.groups;
  const roles = Array.isArray(rolesRaw) ? rolesRaw : rolesRaw ? [rolesRaw] : [];

  const isSuperUser = roles.includes("ROLE_SUPERUSER");

  const handleLogout = async () => {
    if (isLoggingOut) return;

    try {
      setIsLoggingOut(true);
      await instance.logoutRedirect({
        account: activeAccount,
      });
    } catch (error) {
      setIsLoggingOut(false);
      // eslint-disable-next-line no-alert
      alert("Nie udało się wylogować użytkownika.");
    }
  };

  return (
    <Navbar className="custom-navbar shadow-sm" expand="lg">
      <Container fluid>
        <Navbar.Brand href="/" className="d-flex align-items-center gap-2">
          <img src={Logo} alt="DHL Logo" width="100" />
          <span className="navbar-title">Rile System</span>
        </Navbar.Brand>

        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          {isAuthenticated && activeAccount?.username && (
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="link"
                className="navbar-user p-0 text-decoration-none"
              >
                {activeAccount.username}
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ minWidth: 280 }}>
                <Dropdown.Header>Użytkownik</Dropdown.Header>
                <Dropdown.ItemText>
                  <div style={{ fontSize: 12, opacity: 0.7 }}>Role</div>
                  <div style={{ fontWeight: 600 }}>
                    {roles.length > 0 ? roles.join(", ") : "—"}
                  </div>
                </Dropdown.ItemText>

                {!isSuperUser && (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.ItemText>
                      <div style={{ fontSize: 12, opacity: 0.7 }}>
                        Przypisane terminale
                      </div>
                      <div style={{ fontWeight: 600 }}>
                        {branchesLoading
                          ? "Ładowanie…"
                          : (() => {
                              const list = Array.isArray(branches)
                                ? branches
                                : branches?.branches || branches?.data || [];
                              return list.length > 0
                                ? list.map((b) => b.name).join(", ")
                                : "—";
                            })()}
                      </div>
                    </Dropdown.ItemText>
                  </>
                )}

                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout} disabled={isLoggingOut}>
                  {isLoggingOut ? "Wylogowywanie…" : "Wyloguj"}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
